/**
 * @module nhcweb/apps/shared/nhc-modules/basemap-toggle
 */
import './basemap-toggle.css';
import { Control } from 'ol/control.js';

/**
 * @description
 * This module extends the Open Layers control class to create a control that
 * toggles between two base maps. The control is added to the map in the
 * application code.
 */

export class BaseMapToggle extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};
    // The element that will contain the control needs to be created here
    // and passed to the parent constructor.
    options.element = document.createElement('div');
    super(options);
    
    this.options = options;

    // Create elements
    this.basemapBG = document.createElement('div');
    this.basemapBG.className = 'basemapBG';
    this.basemapBG.style.backgroundImage = `url(${this.options.nextLayerImage})`;
    this.basemapBG.title = this.options.nextLayerName;

    this.basemapImage = document.createElement('div');
    this.basemapImage.className = 'basemapImage';
    this.basemapImage.appendChild(this.basemapBG);

    this.basemapTitle = document.createElement('div');
    this.basemapTitle.className = 'basemapTitle';
    this.basemapTitle.title = this.options.nextLayerName;
    this.basemapTitle.textContent = this.options.nextLayerName;

    this.basemapImageContainer = document.createElement('div');
    this.basemapImageContainer.className = 'basemapImageContainer';
    this.basemapImageContainer.appendChild(this.basemapImage);
    this.basemapImageContainer.appendChild(this.basemapTitle);

    this.basemapContainer = document.createElement('div');
    this.basemapContainer.className = 'basemapContainer';
    this.basemapContainer.appendChild(this.basemapImageContainer);
    
    // this.element = document.createElement('div');
    // Note: this.element is created when super(options) is called above
    this.element.className = 'basemapToggle';
    this.element.setAttribute('role', 'presentation');
    this.element.style.display = 'block';
    this.element.id = 'basemapToggle';
    this.element.appendChild(this.basemapContainer);

    // Preload images
    this.startLayerImage = new Image();
    this.startLayerImage.src = this.options.startLayerImage;
    this.nextLayerImage = new Image();
    this.nextLayerImage.src = this.options.nextLayerImage;

  }

  setMap(map) {
    // Call the parent method.
    super.setMap(map);
  
    // Register the event handler if the map is not null.
    if (map) {
      this.element.addEventListener('click', () => {
        if (map.getLayers().getArray().includes(this.options.startLayer)) {
          this.basemapTitle.textContent = this.options.startLayerName;
          this.basemapTitle.title = this.options.startLayerName;
          this.basemapBG.style.backgroundImage = `url(${this.startLayerImage.src})`;
          this.basemapBG.title = this.options.startLayerName;
          map.getLayers().setAt(0, this.options.nextLayer);
        }
        else {
          this.basemapTitle.textContent = this.options.nextLayerName;
          this.basemapTitle.title = this.options.nextLayerName;
          this.basemapBG.style.backgroundImage = `url(${this.nextLayerImage.src})`;
          this.basemapBG.title = this.options.nextLayerName;
          map.getLayers().setAt(0, this.options.startLayer);
        }
      }, false);
    }
  }

}
